import { Component, OnInit, PLATFORM_ID, Inject, OnDestroy } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { SharedService } from '@flowaccount/landing'
import { tutorialsJSONLD } from '../../../models/structuredData/index'
import { HttpClient } from '@angular/common/http'
import videoData from '../../../../assets/tutorials/tutorials.json'
import videoList from '../../../../assets/tutorials/tutorialsV2.json'
import { Pages } from '../../../models/blog.model'
import { Subscription } from 'rxjs'
@Component({
  selector: 'flowaccount-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent implements OnInit, OnDestroy {
  public carrerVideo: Array<any> = []
  public saleAndPurchaseVideo: Array<any> = []
  public payrollVideo: Array<any> = []
  public inventoryVideo: Array<any> = []
  public reportVideo: Array<any> = []
  public accountingManagementVideo: Array<any> = []
  public accountingReportVideo: Array<any> = []
  public settingVideo: Array<any> = []
  public tutorialsLD = tutorialsJSONLD
  public page = Pages
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_TUTORIAL',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_TUTORIAL',
  }

  // เนื้อหาวิดีโอปี 2021 (boolean นี้มี 2 ที่  tutorial และ view-tuterial)
  public isTutorialVideo2021 = true
  public category1_startToUsingFA: Array<any> = []
  public category2_setupYourBusiness: Array<any> = []
  public category3_documents: Array<any> = []
  public category3_1_documents: Array<any> = []
  public category3_2_documents: Array<any> = []
  public category3_3_documents: Array<any> = []
  public category3_4_documents: Array<any> = []
  public category3_5_documents: Array<any> = []
  public category4_audioBlogs: Array<any> = []
  public allVideo
  public categories
  private langChangeSubscription: Subscription

  constructor(
    public sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId,
    public translate: TranslateService,
    private titleService: Title,
    private seoService: SEOService,
    private http: HttpClient,
  ) {
    this.setMeta()
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadScript()
    }

    if (this.isTutorialVideo2021) {
      this.showVideoList2021()
    } else {
      this.showVideoList2020()
    }
  }
  setMeta() {
    const title = this.translate.instant('metatitle-Video')
    const description = this.translate.instant('metaDescription-Video')
    const imageUrl =
      'https://flowaccountcdn.com/new_landing/image/tutorials/SS1/FlowAccount%20Business%20Suite%20ระบบริหารธุรกิจ%20SME.jpg'
    const canonicalUrl = 'https://flowaccount.com/tutorials'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(imageUrl, title, description)
    this.seoService.setCanonicalUrl(canonicalUrl)
  }

  showVideoList2020() {
    const allVideo = videoData.allVideo
    this.carrerVideo = allVideo.filter((item) => item.catagory === 1)
    this.saleAndPurchaseVideo = allVideo.filter((item) => item.catagory === 2)
    this.payrollVideo = allVideo.filter((item) => item.catagory === 3)
    this.inventoryVideo = allVideo.filter((item) => item.catagory === 4)
    this.reportVideo = allVideo.filter((item) => item.catagory === 5)
    this.accountingManagementVideo = allVideo.filter((item) => item.catagory === 6)
    this.accountingReportVideo = allVideo.filter((item) => item.catagory === 7)
    this.settingVideo = allVideo.filter((item) => item.catagory === 8)
  }

  showVideoList2021() {
    this.categories = videoList.categories
    this.allVideo = videoList.allVideo
  }

  strReplace(string) {
    const re = /[\/\s]/gi
    return string.replace(re, '-')
  }

  loadScript() {
    // this.itemLD, this.homeLD,
    const arrayJsonLD = [this.tutorialsLD]
    for (let i = 0; i < arrayJsonLD.length; i++) {
      const itemJsonLD = arrayJsonLD[i] ? JSON.stringify(arrayJsonLD[i], null, 2).replace(/\//g, '\\/') : ''
      const node = document.createElement('script')
      node.type = 'application/ld+json'
      const text = document.createTextNode(itemJsonLD)
      node.appendChild(text)
      document.getElementsByTagName('head')[0].appendChild(node)
    }
  }

  linkVideo(youtubeURL: string) {
    return this.sharedService.openVideoTutorialModal(youtubeURL)
  }
  showAltText(textTH: string, textEN: string): string {
    const lang = this.translate.currentLang
    if (lang === 'th') {
      return textTH
    } else {
      return textEN
    }
  }

  getCategoryVideo(category: number) {
    return this.allVideo.filter((item) => item.category === category)
  }

  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }
}
